export default __webpack_public_path__ + "static/media/mobile_20s@2x.02e8c708.jpg";